import { Auth } from "@/interfaces/domain/User";
import { api } from "@/services/api";

import { storeApiToken } from "./token";

type SignupFields = {
  email: string;
  senha: string;
  tokenExpo?: string;
  nome: string;
  telefone: string;
};

export type SignupCustomerParams = {
  dataNascimento?: string;
} & SignupFields;

export type SignupCompanyParams = {
  razaoSocial: string;
  cnpj: string;
  mediaFaturamento?: number;
  inscricaoEstadual?: string;
  tipoEmpresaId: string;
} & SignupFields;

export async function signupCustomerRequest(params: SignupCustomerParams) {
  const { data } = await api.post<Auth>("/registrar/cliente-b2c", {
    usuario: {
      email: params.email,
      senha: params.senha,
      tipo: "cliente",
      token_expo: params.tokenExpo,
    },
    cliente: {
      tipo: "B2C",
      nome: params.nome,
      telefone: params.telefone,
      data_nascimento: params.dataNascimento,
    },
  });
  await storeApiToken(data.token);
  return data;
}

export async function signupCompanyRequest(params: SignupCompanyParams) {
  const { data } = await api.post<Auth>("/registrar/cliente-b2b", {
    usuario: {
      email: params.email,
      senha: params.senha,
      tipo: "cliente",
      token_expo: params.tokenExpo,
    },
    cliente: {
      tipo: "B2B",
      nome: params.nome,
      telefone: params.telefone,
      razao_social: params.razaoSocial,
      cnpj: params.cnpj,
      media_faturamento: params.mediaFaturamento,
      inscricao_estadual: params.inscricaoEstadual,
      tipo_empresa: params.tipoEmpresaId,
    },
  });
  await storeApiToken(data.token);
  return data;
}
